import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/pages/Index/Index'
import NewsDetail from '@/pages/NewsDetail/NewsDetail'
import Recruit from '@/pages/Recruit/Recruit'
import Honor from '@/pages/Honor/Honor'
import InfoPublic from '@/pages/InfoPublic/InfoPublic'
import Contact from '@/pages/Contact/Contact'
import Policy from '@/pages/Policy/Policy'
import AuctionAnnouncement from '@/pages/Auction/Announcement/AuctionAnnouncement'
import AuctionDisplay from '@/pages/Auction/Display/AuctionDisplay'
import AuctionOther from '@/pages/Auction/Other/AuctionOther'
import CompanyIntro from '@/pages/CompanyIntro/CompanyIntro'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index
    },
    {
      path: '/detail',
      name: 'NewsDetail',
      component: NewsDetail
    },
    {
      path: '/recruit',
      name: 'Recruit',
      component: Recruit
    },
    {
      path: '/info',
      name: 'InfoPublic',
      component: InfoPublic
    },
    {
      path: '/honor',
      name: 'Honor',
      component: Honor
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact
    },
    {
      path: '/policy',
      name: 'Policy',
      component: Policy
    },
    {
      path: '/auction/announcement',
      name: 'AuctionAnnouncement',
      component: AuctionAnnouncement
    },
    {
      path: '/auction/display',
      name: 'AuctionDisplay',
      component: AuctionDisplay
    },
    {
      path: '/auction/other',
      name: 'AuctionOther',
      component: AuctionOther
    },
    {
      path: '/company',
      name: 'CompanyIntro',
      component: CompanyIntro
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js